import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend } from "recharts";
import { Card } from "@/components/ui/card";

const COLORS = ["#5B52EB", "#FFA689", "#81C784", "#FFB74D", "#D0ACF9", "#93D8EF", "#FF96CC", "#FFDA61"];

const Stat = ({ label, value }) => (
  <div className="text-center">
    <p className="font-heading text-xl font-bold">{value}</p>
    <p className="text-[10px] text-muted-foreground uppercase tracking-wider">{label}</p>
  </div>
);

export const WeeklyReportCard = ({ report }) => {
  if (!report) return null;
  return (
    <Card className="mt-2 p-4 space-y-4 max-w-xl" data-testid="weekly-report-card">
      <div className="flex items-center justify-between">
        <p className="font-heading font-bold text-sm">📊 Informe semanal · {report.week_start} → {report.week_end}</p>
      </div>
      <div className="grid grid-cols-4 gap-2">
        <Stat label="Completadas" value={report.tasks_completed} />
        <Stat label="Creadas" value={report.tasks_created} />
        <Stat label="Mensajes" value={report.messages} />
        <Stat label="Gastos" value={`${(report.expenses_total || 0).toFixed(0)} €`} />
      </div>
      <div>
        <p className="text-[11px] font-semibold text-muted-foreground mb-1">Tareas completadas por día</p>
        <ResponsiveContainer width="100%" height={120}>
          <BarChart data={report.by_day}>
            <XAxis dataKey="label" tick={{ fontSize: 9 }} />
            <YAxis tick={{ fontSize: 9 }} width={22} allowDecimals={false} />
            <Tooltip />
            <Bar dataKey="completed" name="Completadas" fill="#5B52EB" radius={[3, 3, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        {(report.by_member || []).length > 0 && (
          <div>
            <p className="text-[11px] font-semibold text-muted-foreground mb-1">Por miembro</p>
            <ResponsiveContainer width="100%" height={150}>
              <PieChart>
                <Pie data={report.by_member} dataKey="completed" nameKey="name" outerRadius={45} label={false}>
                  {report.by_member.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                </Pie>
                <Legend wrapperStyle={{ fontSize: 10 }} />
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
        )}
        {(report.expenses_by_category || []).length > 0 && (
          <div>
            <p className="text-[11px] font-semibold text-muted-foreground mb-1">Gastos por categoría</p>
            <ResponsiveContainer width="100%" height={150}>
              <PieChart>
                <Pie data={report.expenses_by_category} dataKey="total" nameKey="category" outerRadius={45} label={false}>
                  {report.expenses_by_category.map((_, i) => <Cell key={i} fill={COLORS[(i + 3) % COLORS.length]} />)}
                </Pie>
                <Legend wrapperStyle={{ fontSize: 10 }} />
                <Tooltip formatter={(v) => `${Number(v).toFixed(2)} €`} />
              </PieChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>
      {report.realestate && (
        <div className="mt-3 pt-3 border-t space-y-2" data-testid="weekly-realestate">
          <p className="text-[11px] font-semibold text-muted-foreground">🏠 Cartera inmobiliaria · {report.realestate.total} inmuebles</p>
          <div className="grid grid-cols-4 gap-1.5">
            {report.realestate.by_stage.map((s) => (
              <div key={s.stage} className="rounded-lg bg-secondary/60 px-2 py-1.5 text-center"><p className="text-base font-bold leading-none">{s.count}</p><p className="text-[10px] text-muted-foreground">{s.stage}</p></div>
            ))}
          </div>
          <div className="grid grid-cols-2 gap-1.5 text-xs">
            <div className="rounded-lg border px-2 py-1.5"><span className="font-semibold">{report.realestate.visits_last_week}</span> visitas la semana pasada</div>
            <div className="rounded-lg border px-2 py-1.5"><span className="font-semibold">{report.realestate.visits_upcoming}</span> programadas esta semana</div>
          </div>
          {report.realestate.pending?.length > 0 && (
            <div className="text-xs space-y-0.5">
              <p className="font-semibold text-amber-700">📄 {report.realestate.pending_total} documentos obligatorios pendientes</p>
              {report.realestate.pending.map((p) => <p key={p.ref} className="text-muted-foreground truncate">• {p.ref} {p.title} — {p.missing} en {p.stage}: {p.items.join(", ")}{p.missing > 3 ? "…" : ""}</p>)}
            </div>
          )}
        </div>
      )}
    </Card>
  );
};
